import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import { Business, Description, VpnKey, Storage } from "@material-ui/icons";
import React from "react";
import styled, { keyframes } from "styled-components";

function TabEmpresa({ values, touched, errors, handleChange }) {
	return (
		<ModernFormContainer>
			{values.id !== 0 && (
				<SectionCard>
					<SectionHeader>
						<SectionIcon color="#667eea">
							<Business />
						</SectionIcon>
						<SectionTitle>Informações Gerais</SectionTitle>
					</SectionHeader>
					<FormGrid columns={2}>
						<StyledFieldContainer>
							<FieldLabel>
								<Business style={{ fontSize: '18px', marginRight: '8px', color: '#667eea' }} />
								ID
							</FieldLabel>
							<TextField
								fullWidth
								InputLabelProps={{ shrink: true }}
								disabled
								id="id"
								name="id"
								placeholder="ID"
								value={values.id}
								onChange={handleChange}
								error={touched.id && Boolean(errors.id)}
								helperText={touched.id && errors.id}
								autoComplete="off"
								variant="outlined"
							/>
						</StyledFieldContainer>
						<FormLabel>
							<Checkbox
								id="ativo"
								name="ativo"
								checked={values.ativo}
								onChange={handleChange}
								color="primary"
							/>
							<StatusText active={values.ativo}>
								{values.ativo ? "✓ Ativo" : "✗ Inativo"}
							</StatusText>
						</FormLabel>
					</FormGrid>
				</SectionCard>
			)}

			<SectionCard>
				<SectionHeader>
					<SectionIcon color="#3498db">
						<Description />
					</SectionIcon>
					<SectionTitle>Dados da Empresa</SectionTitle>
				</SectionHeader>
				<FormGrid columns={2}>
					<StyledFieldContainer>
						<FieldLabel>
							<Business style={{ fontSize: '18px', marginRight: '8px', color: '#667eea' }} />
							CNPJ
						</FieldLabel>
						<TextField
							fullWidth
							InputLabelProps={{ shrink: true }}
							id="cnpj"
							name="cnpj"
							placeholder="00.000.000/0000-00"
							value={values.cnpj}
							onChange={handleChange}
							error={touched.cnpj && Boolean(errors.cnpj)}
							helperText={touched.cnpj && errors.cnpj}
							autoComplete="off"
							variant="outlined"
						/>
					</StyledFieldContainer>
					<StyledFieldContainer>
						<FieldLabel>
							<Business style={{ fontSize: '18px', marginRight: '8px', color: '#27ae60' }} />
							Nome da Empresa
						</FieldLabel>
						<TextField
							InputLabelProps={{ shrink: true }}
							fullWidth
							id="name"
							name="name"
							placeholder="Nome da empresa"
							value={values.name}
							onChange={handleChange}
							error={touched.name && Boolean(errors.name)}
							helperText={touched.name && errors.name}
							autoComplete="off"
							variant="outlined"
						/>
					</StyledFieldContainer>
					<StyledFieldContainer fullWidth>
						<FieldLabel>
							<Description style={{ fontSize: '18px', marginRight: '8px', color: '#f39c12' }} />
							Descrição
						</FieldLabel>
						<TextField
							InputLabelProps={{ shrink: true }}
							fullWidth
							id="description"
							name="description"
							placeholder="Descrição detalhada da aplicação"
							value={values.description}
							onChange={handleChange}
							error={touched.description && Boolean(errors.description)}
							helperText={touched.description && errors.description}
							autoComplete="off"
							variant="outlined"
							multiline
							rows={2}
						/>
					</StyledFieldContainer>
				</FormGrid>
			</SectionCard>

			{values.id !== 0 && (
				<SectionCard>
					<SectionHeader>
						<SectionIcon color="#9b59b6">
							<VpnKey />
						</SectionIcon>
						<SectionTitle>Token de Integração</SectionTitle>
					</SectionHeader>
					<StyledFieldContainer>
						<FieldLabel>
							<VpnKey style={{ fontSize: '18px', marginRight: '8px', color: '#9b59b6' }} />
							Token
						</FieldLabel>
						<TextField
							fullWidth
							InputLabelProps={{ shrink: true }}
							disabled
							id="token"
							name="token"
							placeholder="Token será gerado automaticamente"
							value={values.token}
							onChange={handleChange}
							error={touched.token && Boolean(errors.token)}
							helperText={touched.token && errors.token}
							autoComplete="off"
							variant="outlined"
						/>
					</StyledFieldContainer>
				</SectionCard>
			)}

			<SectionCard>
				<SectionHeader>
					<SectionIcon color="#16a085">
						<Storage />
					</SectionIcon>
					<SectionTitle>Configurações Avançadas</SectionTitle>
				</SectionHeader>
				{values.id !== 0 && (
					<FormLabel>
						<Checkbox
							id="metadata"
							name="metadata"
							checked={values.metadata}
							onChange={handleChange}
							color="primary"
						/>
						<StatusText active={values.metadata}>
							Habilitar criação automática de tabelas e campos no SAP
						</StatusText>
					</FormLabel>
				)}
				<FormLabel>
					<Checkbox
						id="use_ecc"
						name="use_ecc"
						checked={values.use_ecc}
						onChange={handleChange}
						color="primary"
					/>
					<StatusText active={values.use_ecc}>
						Habilitar o uso do ECC (Isso desabilitará o uso do B1)
					</StatusText>
				</FormLabel>
			</SectionCard>
		</ModernFormContainer>
	);
}

export default TabEmpresa;

// Animações
const fadeIn = keyframes`
	from {
		opacity: 0;
		transform: translateY(10px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
`;

const ModernFormContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
	font-family: 'Mulish', sans-serif;
`;

const SectionCard = styled.div`
	background: white;
	border-radius: 16px;
	padding: 24px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
	border: 1px solid #e8e8e8;
	animation: ${fadeIn} 0.5s ease;
	transition: all 0.3s ease;

	&:hover {
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
		border-color: #d0d0d0;
	}
`;

const SectionHeader = styled.div`
	display: flex;
	align-items: center;
	margin-bottom: 20px;
	padding-bottom: 16px;
	border-bottom: 2px solid #f0f0f0;
`;

const SectionIcon = styled.div`
	width: 40px;
	height: 40px;
	border-radius: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: ${props => props.color ? `${props.color}15` : '#667eea15'};
	color: ${props => props.color || '#667eea'};
	margin-right: 12px;
	transition: all 0.3s ease;

	svg {
		font-size: 22px;
	}

	${SectionCard}:hover & {
		transform: scale(1.1);
	}
`;

const SectionTitle = styled.h3`
	font-size: 18px;
	font-weight: 700;
	color: #2c3e50;
	margin: 0;
	font-family: 'Mulish', sans-serif;
`;

const FormGrid = styled.div`
	display: grid;
	grid-template-columns: ${props => props.columns === 2 ? 'repeat(2, 1fr)' : '1fr'};
	gap: 20px;

	@media (max-width: 768px) {
		grid-template-columns: 1fr;
	}
`;

const StyledFieldContainer = styled.div`
	display: flex;
	flex-direction: column;
	grid-column: ${props => props.fullWidth ? '1 / -1' : 'auto'};

	.MuiOutlinedInput-root {
		border-radius: 10px;
		transition: all 0.3s ease;

		&:hover {
			box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
		}

		&.Mui-focused {
			box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
		}
	}

	.MuiInputLabel-outlined {
		font-family: 'Mulish', sans-serif;
		font-weight: 500;
	}

	.MuiOutlinedInput-input {
		font-family: 'Mulish', sans-serif;
	}
`;

const FieldLabel = styled.label`
	font-size: 14px;
	font-weight: 600;
	color: #2c3e50;
	margin-bottom: 8px;
	display: flex;
	align-items: center;
	font-family: 'Mulish', sans-serif;
`;

const FormLabel = styled.div`
	display: flex;
	align-items: center;
	padding: 12px 0;
	cursor: pointer;
	user-select: none;
	transition: all 0.2s ease;

	&:hover {
		background: rgba(102, 126, 234, 0.05);
		border-radius: 8px;
		padding: 12px 8px;
	}
`;

const StatusText = styled.span`
	font-size: 15px;
	font-weight: 600;
	color: ${props => props.active ? '#27ae60' : '#7f8c8d'};
	font-family: 'Mulish', sans-serif;
	transition: color 0.3s ease;
`;
